import gql from 'graphql-tag'

export const deviceDelete = gql`
  mutation deviceDelete($deviceId: ID!) {
    deviceDelete(input: { deviceId: $deviceId }) {
      success
    }
  }
`
